import React from 'react';
import TextField from '@mui/material/TextField';

export const Locationcontact = () => {
    return (
        <div>
            <form className='sectionalForms'>
                <div className="row">
                    <div className="col-lg-6 col-sm-12">
                        <div className="formdesign">
                            <TextField id="outlined-basic" label="Email" className='w-100' variant="outlined" size="small" />
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <div className="formdesign">
                            <TextField id="outlined-basic" label="Phone Number" className='w-100' variant="outlined" size="small" />
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <div className="formdesign">
                            <TextField id="outlined-basic" label="Alternative Phone Number" className='w-100' variant="outlined" size="small" />
                        </div>
                    </div>                    <div className="col-lg-6 col-sm-12">
                        <div className="formdesign">
                            <TextField id="outlined-basic" label="Website" className='w-100' variant="outlined" size="small" />
                        </div>
                    </div>                    <div className="col-lg-6 col-sm-12">
                        <div className="formdesign">
                            <TextField id="outlined-basic" label="Operational Timings" className='w-100' variant="outlined" size="small" />
                        </div>
                    </div>                    <div className="col-lg-6 col-sm-12">
                        <div className="formdesign">
                            <TextField id="outlined-basic" label="Website" className='w-100' variant="outlined" size="small" />
                        </div>
                    </div>
                    <div className="col-lg-12 col-sm-12">
                        <div className="text-end">
                            <button className='btn btn-blacked outline me-2'>Cancel</button>
                            <button className='btn btn-blacked '>Update</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}
